import { GetStaticPaths, GetStaticProps } from 'next';

import Axios from '~/utils/axios';
import Destinations from '~/components/home-page/destination';
import Discover from '~/components/home-page/discover';
import Features from '~/components/home-page/features';
import Hero from '~/components/home-page/hero';
import React from 'react';
import Trending from '~/components/home-page/trending';
import allSettled from '~/utils/all-settled';
import { getLanguagesPaths } from '~/utils/translate';

const Home = (props: { destinations: any; carouselEvents: any; categories: any }) => {
   const { destinations, carouselEvents, categories } = props;
   return (
      <>
         <Hero />
         <Trending data={carouselEvents} />
         <Destinations data={destinations} />
         <Discover data={categories} />
         <Features />
         {/* <Information />
         <BookYourVisit /> */}
      </>
   );
};
export const getStaticPaths: GetStaticPaths = async () => {
   return {
      paths: getLanguagesPaths(),
      fallback: false,
   };
};

/******************************************************************
 *
 *  THIS PAGE IS USING STATIC SITE GENERATION
 *
 ******************************************************************/

export const getStaticProps: GetStaticProps = async ({ params }) => {
   const locale = params?.lang as string;
   const lang = locale.split('-')[1];
   const getDestinations = () => Axios.get(`/madinah/topics?lang=${lang}`);
   const getRecentAndDeals = () =>
      Axios.get(`home-venues?carousel_venues=true&lang=${lang}&visible_in=Madinah&type=venue`);
   const getCategories = () => Axios.get(`/madinah/topics/categories?lang=${lang}`);
   const [recentAndDeals, destinations, categories] = await allSettled([
      getRecentAndDeals(),
      getDestinations(),
      getCategories(),
   ]);

   const carousel = recentAndDeals.value?.data?.data?.[0];
   recentAndDeals.value?.data?.data?.shift?.();

   // Only take necessary fields from destinations and categories
   const destinationsData = (destinations?.value?.data?.data || []).map((dest: any) => ({
      id: dest._id,
      title: dest.title,
      slug: dest.slug,
      short_description: dest?.short_description || null,
      images: dest.images,
      // Add only other essential fields you need
   }));

   const categoriesData = (categories.value?.data || []).map((cat: any) => ({
      id: cat._id,
      name: cat.name,
      slug: cat.slug,
      // Add only other essential fields you need
   }));

   // Optimize carousel events data
   const carouselEvents =
      carousel?.data?.map((item: any) => ({
         id: item._id,
         title: item.name,
         price: Math.min(item.discounted_price, item.list_price),
         price_start_from: item.price_start_from,
         src: item.venue_image,
         type: item.type,
         description: item.description,
         href:
            item.type === 'events'
               ? `/tickets/${item?.event_is_group ? 'group/' : ''}${item.slug}`
               : `/experiences/${item?.region?.slug || item?.city_slug}/${item.category?.slug}/${item.slug}`,
         event_is_group: item?.event_is_group || false,
      })) || [];

   return {
      revalidate: 90,
      props: {
         carouselEvents,
         destinations: destinationsData,
         categories: categoriesData,
      },
   };
};
Home.transparentNavbar = true;
export default Home;
